/**
 * Centralized post-login landing route by role, with an optional
 * commerce_model dimension for the seller path.
 *
 * Routing rules today:
 *   - primary_owner / owner → /command-center
 *   - agent                 → /admin-dashboard
 *   - user (seller)         → /dashboard (all commerce models, for now)
 *
 * Structure is intentionally case-based on commerce_model so that adding
 * model-specific routes in Step 3/4 requires only a new case, not a rewrite.
 */
import type { CommerceModel } from "@/lib/commerce-model";

export type PostLoginRole =
  | "primary_owner"
  | "owner"
  | "agent"
  | "user"
  | string
  | null
  | undefined;

export function getPostLoginRedirect(
  role: PostLoginRole,
  commerceModel?: CommerceModel | null,
): string {
  if (role === "primary_owner" || role === "owner") return "/command-center";
  if (role === "agent") return "/admin-dashboard";

  // Seller path — model-aware. Every case currently returns /dashboard;
  // Step 3/4 will diverge here without restructuring the function.
  switch (commerceModel) {
    case "dropshipping":
      return "/dashboard";
    case "digital":
      return "/dashboard";
    case "hybrid":
      return "/dashboard";
    case "cod":
    default:
      return "/dashboard";
  }
}
